// API Configuration for different environments
const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:5001',
  },
  production: {
    baseURL: 'https://web-production-1ada.up.railway.app',
  }
};

// Determine environment
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development';

// For Vercel deployment, we're always calling Railway backend
const getApiConfig = () => {
  // If we're on Vercel (production build), use Railway backend
  if (isProduction) {
    return API_CONFIG.production;
  }
  
  // If we're in local development, use localhost
  if (isDevelopment) {
    return API_CONFIG.development;
  }
  
  // Default to production config
  return API_CONFIG.production;
};

export const API_BASE_URL = getApiConfig().baseURL;

// Helper function to create full API URLs
export const createApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

export default {
  API_BASE_URL,
  createApiUrl
};